import React from 'react';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import ErrorIcon from '../../../assets/images/icons/Error_Icon.svg';

export default function GenericError({ title = 'Sorry, something went wrong', children, id }) {
    return (
        <Box id="error-page-container" className="beacon-theme-modern-outlook beacon-on-light">
            <Box id="error-img-container" sx={{ paddingBottom: '12px' }}>
                <img src={ErrorIcon} alt="loading-error" id={`${id}-error-img}`} />
            </Box>
            <Typography
                type="headline" serif loose scale={400} bold
                id={`${id}-error-title`}
                sx={{ paddingBottom: '16px' }}>
                {title}
            </Typography>
            <Typography
                light
                id={`${id}-error-message`}>
                {children}
            </Typography>
        </Box>
    );
}
